import { Box, Card, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

const StyledIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(10),
  height: theme.spacing(10),
  borderRadius: '50%',
  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0)} 0%, ${alpha(theme.palette.primary.main, 0.24)} 100%)`,
  margin: '0 auto',
  marginBottom: theme.spacing(3),
}));

export default function InfoCard({
  title,
  total,
  icon,
  color = 'primary',
  sx,
  ...other
}) {
  return (
    <Card
      sx={{
        textAlign: 'center',
        padding: theme => `${theme.spacing(3)} ${theme.spacing(2)}`,
        ...sx,
      }}
      {...other}
    >
      <StyledIcon>
        <Box sx={{ color: theme => theme.palette[color].dark }}>
          {icon}
        </Box>
      </StyledIcon>
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        {total}
      </Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.7 }}>
        {title}
      </Typography>
    </Card>
  );
}
